import React from 'react';

const Loading = () => {
    return (
        <main className="wrap">
            <div className="loading">
                <div className="loading-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </main>
    );
};

export default Loading;